import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { QRCategories } from './qrCategories.model';

@Injectable({
  providedIn: 'root'
})
export class QrcommissioncategoriesService {

  constructor(private http: HttpClient, private global: Globle) {

  }
  
  getAll() {
    return this.http.get<QRCategories[]>(this.global.APIURLV2 + "qrtranscategory");
  }

  getById(id: number) {
    return this.http.get<QRCategories>(this.global.APIURLV2 + "qrtranscategory/" + id);
  }

  Create(_qrCategories: QRCategories) {
    return this.http.post(this.global.APIURLV2 + "qrtranscategory", _qrCategories)
  }

  Update(_qrCategories: QRCategories) {
    return this.http.put(this.global.APIURLV2 + "qrtranscategory", _qrCategories)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURLV2 + "qrtranscategory/" + id)
  }
}
